<template>
  <div class="invoice-success-page">
    <img src="@/assets/img/issueInvoice/success_tips.png" class="topImg" />
    <p class="msg">提交成功</p>
    <p class="money">开票金额：￥{{ Money(amount) }}</p>
    <p class="Info">您可以在开票历史页面去查看开票详情</p>
    <div class="btnBox">
      <span class="return" @click="goBack">返回</span>
      <span class="history" @click="goHistory">开票历史</span>
    </div>
  </div>
</template>

<script>
import { getUrlParameter } from "@/utils/utils.js";
export default {
  data() {
    return {
      amount: "",
    };
  },
  mounted() {
    // document.title = "开具电子发票";
    let amount = getUrlParameter("amount");
    this.amount = amount;
  },
  methods: {
    goHistory() {
      this.$router.push({ name: "invoiceHistory" });
    },
    goBack() {
      window.history.go(-1);
    },
    Money(value, num) {
      num = num > 0 && num <= 20 ? num : 2;
      value =
        parseFloat((value + "").replace(/[^\d.-]/g, "")).toFixed(num) + ""; //将金额转成比如 123.45的字符串
      var valueArr = value.split(".")[0].split(""); //将字符串的数变成数组
      const valueFloat = value.split(".")[1]; // 取到 小数点后的值
      let valueString = "";
      for (let i = 0; i < valueArr.length; i++) {
        valueString += valueArr[i]; //循环 取数值并在每三位加个','
      }
      const money = valueString.split("").join("") + "." + valueFloat; //拼接上小数位
      return money;
    },
  },
};
</script>

<style lang="scss" scoped>
.invoice-success-page {
  width: 100%;
  position: relative;
  text-align: center;
  background-color: #ffffff;
  height: 100vh;
  .topImg {
    width: 60px;
    height: 69px;
    margin-bottom: 15px;
    margin-top: 75px;
  }

  .msg {
    font-size: 18px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: bold;
    color: rgba(51, 51, 51, 1);
    line-height: 18px;
    margin-bottom: 11px;
  }
  .money {
    height: 18px;
    font-size: 15px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(51, 51, 51, 1);
    line-height: 18px;
    margin-bottom: 19px;
  }
  .Info {
    font-size: 15px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(102, 102, 102, 1);
    line-height: 15px;
    margin-bottom: 30px;
  }
  .btnBox {
    display: block;
    text-align: center;
    span {
      display: inline-block;
      width: 106px;
      height: 28px;
      background-image: url("~@/assets/img/issueInvoice/btnImg.png");
      background-repeat: no-repeat;
      background-size: 100% 99.9%;
      line-height: 28px;
      text-align: center;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(102, 102, 102, 1);
    }
    .return {
      margin-right: 20px;
    }
  }
}
</style>
